// extracted by mini-css-extract-plugin
var _1 = "RecipientTag-moduleRecipientTag__h6Gwc Tag-moduleTag__FLr9H";
var _2 = "RecipientTag-moduleadditional__LlTCq";
var _3 = "RecipientTag-moduleclosedTag__S0sa7";
var _4 = "RecipientTag-moduledisabled__W3LDr";
export { _1 as "RecipientTag", _2 as "additional", _3 as "closedTag", _4 as "disabled" }
